import { COLORS } from '@Commons';
import styled from 'styled-components';

export const ShimmerParentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const ShimmerContainer = styled.div`
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const ShimmerDocInfoContainer = styled.div`
  width: 100%;
  border: 1px solid ${COLORS.borderGrey};
  padding: 16px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 9fr 1fr;
  gap: 12px;
  margin-top: 16px;
`;

export const ShimmerDocTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
